<template>
  <a-modal
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    :visible="visible"
    :title="title"
    :destroyOnClose="destroyOnClose"
    @ok="submitForm"
    @cancel="handleCancel"
  >
    <CardEdit
      ref="form"
      :source-data="sourceData"
      :schema="BUSINESS_SCHEMA"
      layout="horizontal"
      :labelCol="labelCol"
      :wrapperCol="wrapperCol"
      :defaultColXs="defaultColXs"
      :defaultColSm="defaultColSm"
      :defaultColMd="defaultColMd"
      :defaultColLg="defaultColLg"
      :defaultColXl="defaultColXl"
    >
      <!--所属角色 slot-->
      <template v-slot:role="slotProps">
        <a-checkbox-group
          v-decorator="
            $decorator(slotProps.item.key, '', [], {
              initialValue: sourceData.roleIds,
            })
          "
        >
          <a-row>
            <a-col :span="12" v-for="item in checkboxList" :key="item.id">
              <a-checkbox :value="item.id">{{ item.name }}</a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </template>
    </CardEdit>
  </a-modal>
</template>
<script>
import { CardEdit } from 'lxfintech-fe'
import BUSINESS_SCHEMA from '../schema'
import { addUser, getRoleList } from '../api'
export default {
  components: {
    CardEdit,
  },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      BUSINESS_SCHEMA,
      sourceData: {
        id: '',
        username: '',
        name: '',
        department: '',
        mobile: '',
        email: '',
        roleIds: [],
      },
      defaultColXs: 24,
      defaultColLg: 24,
      defaultColSm: 24,
      defaultColMd: 24,
      defaultColXl: 24,
      formLayout: 'horizontal',
      labelCol: {
        xs: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 16 },
      },
      checkboxList: [],
      tableRow: {},
      filters: [],
      title: '新增用户',
      destroyOnClose: true,
    }
  },
  methods: {
    // 新增
    add() {
      this.visible = true
      this.$nextTick(() => {
        // 初始化数据
        for (let key in this.sourceData) {
          if (typeof this.sourceData[key] == 'object') {
            this.sourceData[key] = []
          } else {
            this.sourceData[key] = ''
          }
        }
      })
      this.title = '新增用户'
      this._getRoleList()
    },
    // 维护
    async edit(tableRow) {
      this.title = '维护用户'
      await this._getRoleList()
      this.visible = true
      this.$nextTick(() => {
        this.tableRow = tableRow
        const { roleNames } = tableRow
        for (let key in this.sourceData) {
          this.sourceData[key] = tableRow[key]
        }
        this.sourceData.roleIds = []
        this.checkboxList.filter(i => {
          roleNames.filter(j => {
            if (i.name == j) {
              this.sourceData.roleIds.push(i.id)
            }
          })
        })
      })
    },

    // 取消
    handleCancel() {
      this.visible = false
    },
    // 校验数据
    async validateForm() {
      const values = await this.$refs.form.handleSubmit()
      const passed = !!values
      if (passed) {
        for (let key in this.sourceData) {
          if (key != 'id') {
            this.sourceData[key] = values[key]
          }
        }
        return this.sourceData
      }
    },
    // 新增|维护 -接口
    async submitForm() {
      const data = await this.validateForm()
      if (data) {
        addUser(data).then(() => {
          this.$message.success('添加成功')
          this.visible = false
          this.$emit('getTableList')
        })
      }
    },
    // 获取所属角色-接口
    async _getRoleList() {
      await getRoleList().then(({ data }) => {
        this.checkboxList = data
      })
    },
  },
}
</script>
